import React, { useState } from 'react';
import { IconArrowRight, IconAt, IconKey, IconLayersIntersect } from '@tabler/icons-react';
import { useForm } from 'react-hook-form';
import { FormField } from '../../../shared/ui/FormField';
import { TextInput } from '../../../shared/ui/TextInput';
import { useAuth } from '../model/authStore';
import { useNavigate, useLocation } from "react-router-dom";

interface LoginFormValues {
  email: string;
  password: string;
}

const LoginForm: React.FC = () => {
  const { login } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const successMessage = (location.state as { message?: string } | null)?.message ?? '';
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormValues>({
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const handleFormSubmit = handleSubmit(async values => {
    setError('');
    setLoading(true);
    try {
      await login(values.email.trim(), values.password);
      navigate('/');
    } catch (err) {
      setError('Неверный логин или пароль');
    } finally {
      setLoading(false);
    }
  });

  return (
    <div id="login-screen">
      <div className="login-card">
        <div className="logo">
          <div className="logo-icon">
            <IconLayersIntersect size={26} stroke={2} />
          </div>
        <div className="logo-text">CRM<span>Panel</span></div>
        </div>
        <div className="login-title">Добро пожаловать</div>
        <div className="login-sub">Войдите в свою учётную запись</div>
        {successMessage && <div className="login-success">{successMessage}</div>}
        <form onSubmit={handleFormSubmit}>
          <FormField className="field" htmlFor="login-email" label="Логин" error={errors.email?.message}>
            <TextInput
              id="login-email"
              controlClassName="field-with-icon"
              icon={<IconAt size={16} stroke={1.9} />}
              placeholder="e-mail"
              type="text"
              autoComplete="username"
              {...register('email', {
                required: 'Введите логин',
              })}
            />
          </FormField>
          <FormField className="field" htmlFor="login-password" label="Пароль" error={errors.password?.message}>
            <TextInput
              id="login-password"
              controlClassName="field-with-icon"
              icon={<IconKey size={16} stroke={1.9} />}
              placeholder="••••••••"
              type="password"
              autoComplete="current-password"
              {...register('password', {
                required: 'Введите пароль',
              })}
            />
          </FormField>
          {error && <div className="login-error">{error}</div>}
          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? 'Вход...' : (
              <>
                <span>Войти в систему</span>
                <IconArrowRight size={18} stroke={2.2} />
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export { LoginForm };
